import React from "react";

// #ffb7ce #cccccc #fff1f5 #FFB7CF
const OrderInfo = ({ ordered }) => {
	return (
		<div className="w-full">
			<div className="w-full bg-white rounded-2xl border-none">
				<div className="w-full p-4 md:p-6">
					<div className="flex justify-between items-center mb-4">
						<h4 className="font-bold md:text-xl text-lg text-gray-900">Order Items</h4>
						<h5 className="state font-semibold text-[#FFB7CF] tracking-wide px-3 py-1 text-xs bg-[#fff1f5] rounded-full capitalize">
							{ordered.status}
						</h5>
					</div>
					{!ordered.tracking === "paid" && (
						<p className="md:text-sm text-xs font-medium text-gray-500 mb-4 bg-gray-50 p-3 rounded-xl border border-gray-100">
							Make payment for your goods and get your items
						</p>
					)}

					<div className="order-item w-full">
						<div className="order-item-in w-full">
							<div className="flex flex-col sm:flex-row w-full justify-between sm:items-center gap-4">
								<div className="left flex gap-x-4 items-center">
									<div className="image bg-gray-50 rounded-xl overflow-hidden h-16 w-16 md:h-20 md:w-20 shadow-sm flex-shrink-0">
										{ordered.images && (
											<img
												src={ordered.images[0]}
												alt=""
												className="w-full h-full object-cover"
											/>
										)}
									</div>
									<div className="text-sm flex-1 min-w-0">
										<h4 className="Item-name font-bold text-gray-900 text-base md:text-lg truncate">{ordered.name}</h4>
										<h6 className="item text-gray-500 text-xs md:text-sm truncate max-w-[200px] md:max-w-[300px]">
											{ordered.description}
										</h6>
										<div className="colors gap-x-2 text-xs flex font-medium mt-2">
											<span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-md">
												Glossy
											</span>
											<span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-md">
												{ordered.color}
											</span>
											<div className="color-picked w-6 h-6 rounded-full border border-gray-200 shadow-inner" style={{ backgroundColor: ordered.color || 'black' }}></div>
										</div>
									</div>
								</div>
								<div className="right flex sm:flex-col items-center sm:items-end justify-between sm:justify-center gap-2 text-sm mt-2 sm:mt-0 pt-3 sm:pt-0 border-t sm:border-t-0 border-gray-100">
									<span className="amount text-gray-500 font-medium bg-gray-50 px-3 py-1 rounded-lg">
										Qty: {ordered.quantity}
									</span>
									<span className="cost text-gray-900 font-bold text-lg">
										${ordered?.initial_price?.unit_amount}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="w-full py-3 px-4 md:px-6 flex items-center bg-[#fff1f5] mt-2 rounded-b-2xl border-t border-red-50">
					<div className="w-full flex font-medium text-xs md:text-sm justify-between items-center">
						<p className="text-gray-600 flex items-center gap-2">
							<svg className="w-4 h-4 text-[#FFB7CF]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
							Effectively manage your order in our order page
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OrderInfo;
